var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { ModalBody } from 'reactstrap';
var ModalBodyWithBoundary = /** @class */ (function (_super) {
    __extends(ModalBodyWithBoundary, _super);
    function ModalBodyWithBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            hasError: false,
            error: null,
            componentStack: null
        };
        return _this;
    }
    ModalBodyWithBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        this.setState({
            hasError: true,
            error: error,
            componentStack: errorInfo.componentStack
        });
    };
    ModalBodyWithBoundary.prototype.render = function () {
        if (this.state.hasError) {
            var error = this.state.error;
            var message = error ? error.message : 'Error';
            return (React.createElement("div", { className: "error-container" },
                React.createElement("h2", null, "Something went wrong"),
                React.createElement("p", null, "Please contact support."),
                React.createElement("div", { className: "stack-block" },
                    React.createElement("h3", null, message),
                    "The above error occurred in:",
                    this.state.componentStack)));
        }
        return React.createElement(ModalBody, __assign({}, this.props), this.props.children);
    };
    return ModalBodyWithBoundary;
}(React.Component));
export default ModalBodyWithBoundary;
